import ApplicantsStep from '@/views/customer-application/ApplicantsStep.vue';
import AssetsStep from '@/views/customer-application/AssetsStep.vue';
import ExpensesStep from '@/views/customer-application/ExpensesStep.vue';
import FinishedStep from '@/views/customer-application/FinishedStep.vue';
import IncomeStep from '@/views/customer-application/IncomeStep.vue';
import IncomingPropertyStep from '@/views/customer-application/IncomingPropertyStep.vue';
import LoanDetailsStep from '@/views/customer-application/LoanDetailsStep.vue';
import LoanSummaryStep from '@/views/customer-application/LoanSummaryStep.vue';
import LoanTypeStep from '@/views/customer-application/LoanTypeStep.vue';
import OutgoingPropertiesStep from '@/views/customer-application/OutgoingPropertiesStep.vue';
import PropertyOwnershipStep from '@/views/customer-application/PropertyOwnershipStep.vue';
import ReadyStep from '@/views/customer-application/ReadyStep.vue';
import SubmissionStep from '@/views/customer-application/SubmissionStep.vue';
import VerificationStep from '@/views/customer-application/VerificationStep.vue';
import { useFeatureFlags } from '@/helpers/useFeatureFlags';
import { resolveBrokerIdentity } from '@/helpers/brokerIdentity';
import { erhlCustomerGuard } from './erhlCustomerGuard';
import type { RouteRecordRaw } from 'vue-router';

import BrokerAssetsSteps from '@/views/broker-application/AssetsStep.vue';
import BrokerExpensesStep from '@/views/broker-application/ExpensesStep.vue';
import BrokerIncomeStep from '@/views/broker-application/IncomeStep.vue';
import BrokerLoanDetailsStep from '@/views/broker-application/LoanDetailsStep.vue';
import BrokerExitStrategyStep from '@/views/broker-application/ExitStrategyStep.vue';
import BrokerApplicantStep from '@/views/broker-application/BorrowerDetailsStep.vue';
import BrokerLoanPurposeStep from '@/views/broker-application/LoanPurposeStep.vue';
import BrokerLoanTypeStep from '@/views/broker-application/LoanTypeStep.vue';
import BrokerPropertyOwnershipStep from '@/views/broker-application/PropertyOwnershipStep.vue';
import BrokerPropertyDetailsStep from '@/views/broker-application/PropertyDetailsStep.vue';
import BrokerReadyStep from '@/views/broker-application/ReadyStep.vue';
import BrokerSubmissionStep from '@/views/broker-application/SubmissionStep.vue';

import ErhlAssetsStep from '@/views/erhl-application/AssetsStep.vue';
import ErhlExpensesStep from '@/views/erhl-application/ExpensesStep.vue';
import ErhlIncomeStep from '@/views/erhl-application/IncomeStep.vue';
import ErhlExitStrategyStep from '@/views/erhl-application/ExitStrategyStep.vue';
import ErhlApplicantStep from '@/views/erhl-application/BorrowerDetailsStep.vue';
import ErhlLoanPurposeStep from '@/views/erhl-application/LoanPurposeStep.vue';
import ErhlPropertyOwnershipStep from '@/views/erhl-application/PropertyOwnershipStep.vue';
import ErhlPropertyDetailsStep from '@/views/erhl-application/PropertyDetailsStep.vue';
import ErhlLoanDetailsStep from '@/views/erhl-application/LoanDetailsStep.vue';
import ErhlReadyStep from '@/views/erhl-application/ReadyStep.vue';
import ErhlSubmissionStep from '@/views/erhl-application/SubmissionStep.vue';
import ErhlFinishedStep from '@/views/erhl-application/FinishedStep.vue';

import ErhlCustomerAssetsStep from '@/views/erhl-customer-application/AssetsStep.vue';
import ErhlCustomerExpensesStep from '@/views/erhl-customer-application/ExpensesStep.vue';
import ErhlCustomerIncomeStep from '@/views/erhl-customer-application/IncomeStep.vue';
import ErhlCustomerExitStrategyStep from '@/views/erhl-customer-application/ExitStrategyStep.vue';
import ErhlCustomerApplicantStep from '@/views/erhl-customer-application/BorrowerDetailsStep.vue';
import ErhlCustomerLoanPurposeStep from '@/views/erhl-customer-application/LoanPurposeStep.vue';
import ErhlCustomerPropertyOwnershipStep from '@/views/erhl-customer-application/PropertyOwnershipStep.vue';
import ErhlCustomerPropertyDetailsStep from '@/views/erhl-customer-application/PropertyDetailsStep.vue';
import ErhlCustomerLoanDetailsStep from '@/views/erhl-customer-application/LoanDetailsStep.vue';
import ErhlCustomerReadyStep from '@/views/erhl-customer-application/ReadyStep.vue';
import ErhlCustomerVerificationStep from '@/views/erhl-customer-application/VerificationStep.vue';
import ErhlCustomerSubmissionStep from '@/views/erhl-customer-application/SubmissionStep.vue';
import ErhlCustomerFinishedStep from '@/views/erhl-customer-application/FinishedStep.vue';

import DeclarationAssetsStep from '@/views/applicant-declaration/AssetsStep.vue';
import DeclarationExpensesStep from '@/views/applicant-declaration/ExpensesStep.vue';
import DeclarationIncomeStep from '@/views/applicant-declaration/IncomeStep.vue';
import DeclarationLoanSummaryStep from '@/views/applicant-declaration/LoanSummaryStep.vue';
import DeclarationReadyStep from '@/views/applicant-declaration/ReadyStep.vue';
import DeclarationSubmissionStep from '@/views/applicant-declaration/SubmissionStep.vue';
import DeclarationVerificationStep from '@/views/applicant-declaration/VerificationStep.vue';

import RequestAssetsStep from '@/views/income-expense-request/AssetsStep.vue';
import RequestExpensesStep from '@/views/income-expense-request/ExpensesStep.vue';
import RequestIncomeStep from '@/views/income-expense-request/IncomeStep.vue';
import RequestLoanSummaryStep from '@/views/income-expense-request/LoanSummaryStep.vue';
import RequestReadyStep from '@/views/income-expense-request/ReadyStep.vue';
import RequestSubmissionStep from '@/views/income-expense-request/SubmissionStep.vue';

import DischargeRequestReadyStep from '@/views/discharge-request/ReadyStep.vue';
import DischargeRequestStep from '@/views/discharge-request/DischargeRequest.vue';
import DischargeRequestRepresentativeDetailsStep from '@/views/discharge-request/RepresentativeDetails.vue';
import DischargeRequestSubmissionStep from '@/views/discharge-request/SubmissionStep.vue';

import CustomerQuoteReadyStep from '@/views/customer-quote/ReadyStep.vue';
// import CustomerQuoteStartStep from '@/views/customer-quote/StartStep.vue';
import CustomerQuoteIncomingPropertyStep from '@/views/customer-quote/IncomingPropertyStep.vue';
import CustomerQuoteOutgoingPropertyStep from '@/views/customer-quote/OutgoingPropertiesStep.vue';
import CustomerQuoteLoanDetailsStep from '@/views/customer-quote/LoanDetailsStep.vue';
import CustomerQuoteApplicantsStep from '@/views/customer-quote/ApplicantsStep.vue';
import CustomerQuotePropertyOwnership from '@/views/customer-quote/PropertyOwnershipStep.vue';
import CustomerQuoteIncomeStep from '@/views/customer-quote/IncomeStep.vue';
import CustomerQuoteExpensesStep from '@/views/customer-quote/ExpensesStep.vue';
import CustomerQuoteAssetsStep from '@/views/customer-quote/AssetsStep.vue';
import CustomerQuoteVerificationStep from '@/views/customer-quote/VerificationStep.vue';
import CustomerQuoteSubmissionStep from '@/views/customer-quote/SubmissionStep.vue';

import UserQuoteReadyStep from '@/views/user-quote/ReadyStep.vue';
import UserQuoteVerificationStep from '@/views/user-quote/VerificationStep.vue';
import UserQuoteUnaccreditedBrokerStep from '@/views/user-quote/UnaccreditedBrokerStep.vue';
import UserQuoteStartStep from '@/views/user-quote/StartStep.vue';
import UserQuoteLoanTypeStep from '@/views/user-quote/LoanTypeStep.vue';
import UserQuoteLoanPurposeStep from '@/views/user-quote/LoanPurposeStep.vue';
import UserQuoteIncomingPropertyStep from '@/views/user-quote/IncomingPropertyStep.vue';
import UserQuoteOutgoingPropertyStep from '@/views/user-quote/OutgoingPropertiesStep.vue';
import UserQuoteLoanDetailsStep from '@/views/user-quote/LoanDetailsStep.vue';
import UserQuoteApplicantsStep from '@/views/user-quote/ApplicantsStep.vue';
import UserQuotePropertyOwnership from '@/views/user-quote/PropertyOwnershipStep.vue';
import UserQuoteIncomeStep from '@/views/user-quote/IncomeStep.vue';
import UserQuoteExpensesStep from '@/views/user-quote/ExpensesStep.vue';
import UserQuoteAssetsStep from '@/views/user-quote/AssetsStep.vue';
import UserQuoteSubmissionStep from '@/views/user-quote/SubmissionStep.vue';

import QuoteFinishedStep from '@/views/QuoteFinishedStep.vue';

import type { UtmMetricDto } from '@/api/backend/users/applications';

export const loanApplicationRoutes: RouteRecordRaw[] = [
  {
    path: '/application',
    meta: {
      layout: 'CustomerApplicationLayout',
      title: 'Customer | Loan Application',
    },
    children: [
      {
        path: '',
        name: 'application',
        component: ReadyStep,
      },
      {
        path: 'loan-type',
        name: 'selectLoanType',
        component: LoanTypeStep,
      },
      {
        path: 'buying/loan-purpose',
        name: 'incomingProperties',
        component: IncomingPropertyStep,
      },
      {
        path: 'selling/property',
        name: 'outgoingProperties',
        component: OutgoingPropertiesStep,
      },
      {
        path: 'loan-details/additional-funds',
        name: 'loanDetails',
        component: LoanDetailsStep,
      },
      {
        path: 'applicant/details',
        name: 'applicantDetails',
        component: ApplicantsStep,
      },
      {
        path: 'property-ownership',
        name: 'propertyOwnership',
        component: PropertyOwnershipStep,
      },
      {
        path: 'summary',
        name: 'summary',
        component: LoanSummaryStep,
      },
      {
        path: 'income/source',
        name: 'income',
        component: IncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'expenses',
        component: ExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'assets',
        component: AssetsStep,
      },
      {
        path: 'verify/mobile-number',
        name: 'verification',
        component: VerificationStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'submitApplication',
        component: SubmissionStep,
      },
    ],
  },
  {
    path: '/broker-application',
    meta: {
      layout: 'BrokerApplicationLayout',
      title: 'Broker | Loan Application',
    },
    children: [
      {
        path: '',
        name: 'broker',
        component: BrokerReadyStep,
      },
      {
        path: 'loan-type',
        name: 'brokerSelectLoanType',
        component: BrokerLoanTypeStep,
      },
      {
        path: 'loan-purpose',
        name: 'brokerLoanPurpose',
        component: BrokerLoanPurposeStep,
      },
      {
        path: 'property-details',
        name: 'brokerPropertyDetails',
        component: BrokerPropertyDetailsStep,
      },
      {
        path: 'loan-details/additional-funds',
        name: 'brokerLoanDetails',
        component: BrokerLoanDetailsStep,
      },
      {
        path: 'applicant/details',
        name: 'brokerApplicantDetails',
        component: BrokerApplicantStep,
      },
      {
        path: 'exit-strategy',
        name: 'brokerExitStrategy',
        component: BrokerExitStrategyStep,
      },
      {
        path: 'property-ownership',
        name: 'brokerPropertyOwnership',
        component: BrokerPropertyOwnershipStep,
      },
      {
        path: 'income/source',
        name: 'brokerIncome',
        component: BrokerIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'brokerExpenses',
        component: BrokerExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'brokerAssets',
        component: BrokerAssetsSteps,
      },
      {
        path: 'declaration/declaration-form',
        name: 'brokerSubmitApplication',
        component: BrokerSubmissionStep,
      },
    ],
  },
  {
    path: '/declaration',
    meta: {
      layout: 'DeclarationLayout',
      title: 'Declaration | Loan Application',
    },
    children: [
      {
        path: '',
        name: 'declaration',
        component: DeclarationReadyStep,
      },
      {
        path: 'summary',
        name: 'declarationSummary',
        component: DeclarationLoanSummaryStep,
      },
      {
        path: 'income/source',
        name: 'declarationIncome',
        component: DeclarationIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'declarationExpenses',
        component: DeclarationExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'declarationAssets',
        component: DeclarationAssetsStep,
      },
      {
        path: 'verify/mobile-number',
        name: 'declarationVerification',
        component: DeclarationVerificationStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'declarationSubmitApplication',
        component: DeclarationSubmissionStep,
      },
    ],
  },
  {
    path: '/discharge',
    meta: {
      layout: 'DischargeRequestLayout',
      title: 'Submit Discharge Request',
    },
    children: [
      {
        path: '',
        name: 'discharge',
        component: DischargeRequestReadyStep,
      },
      {
        path: 'request',
        name: 'dischargeRequest',
        component: DischargeRequestStep,
      },
      {
        path: 'request/representative-details',
        name: 'representativeDetails',
        component: DischargeRequestRepresentativeDetailsStep,
      },
      {
        path: 'request/discharge-request-form',
        name: 'submitDischargeRequest',
        component: DischargeRequestSubmissionStep,
      },
    ],
  },
  {
    path: '/income-expense',
    meta: {
      layout: 'RequestIncomeExpenseLayout',
      title: 'Loan Application',
    },
    children: [
      {
        path: '',
        name: 'request',
        component: RequestReadyStep,
      },
      {
        path: 'summary',
        name: 'requestSummary',
        component: RequestLoanSummaryStep,
      },
      {
        path: 'income/source',
        name: 'requestIncome',
        component: RequestIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'requestExpenses',
        component: RequestExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'requestAssets',
        component: RequestAssetsStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'requestSubmitApplication',
        component: RequestSubmissionStep,
      },
    ],
  },
  {
    path: '/customer-quote',
    meta: {
      layout: 'CustomerQuoteLayout',
      title: 'Customer | Submit Quote',
    },
    children: [
      {
        path: '',
        name: 'customerQuote',
        component: CustomerQuoteReadyStep,
        props: ({ query }) => {
          const utmMetrics = <UtmMetricDto>{
            firstClickSource: (query.utm_source_f as string) ?? '',
            firstClickMedium: (query.utm_medium_f as string) ?? '',
            firstClickCampaign: (query.utm_campaign_f as string) ?? '',
            firstClickContent: (query.utm_content_f as string) ?? '',
            firstClickTerm: (query.utm_term_f as string) ?? '',
            secondClickSource: (query.utm_source as string) ?? '',
            secondClickMedium: (query.utm_medium as string) ?? '',
            secondClickCampaign: (query.utm_campaign as string) ?? '',
            secondClickContent: (query.utm_content as string) ?? '',
            secondClickTerm: (query.utm_term as string) ?? '',
            intSource: (query.int_source as string) ?? '',
          };

          return { utmMetrics };
        },
      },
      // {
      //   path: 'start',
      //   name: 'startQuote',
      //   component: CustomerQuoteStartStep,
      // },
      {
        path: 'buying/loan-purpose',
        name: 'cqIncomingProperties',
        component: CustomerQuoteIncomingPropertyStep,
      },
      {
        path: 'selling/property',
        name: 'cqOutgoingProperties',
        component: CustomerQuoteOutgoingPropertyStep,
      },
      {
        path: 'loan-details/additional-funds',
        name: 'cqLoanDetails',
        component: CustomerQuoteLoanDetailsStep,
      },
      {
        path: 'applicant/details',
        name: 'cqApplicantDetails',
        component: CustomerQuoteApplicantsStep,
      },
      {
        path: 'property-ownership',
        name: 'cqPropertyOwnership',
        component: CustomerQuotePropertyOwnership,
      },
      {
        path: 'income/source',
        name: 'cqIncome',
        component: CustomerQuoteIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'cqExpenses',
        component: CustomerQuoteExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'cqAssets',
        component: CustomerQuoteAssetsStep,
      },
      {
        path: 'verify/mobile-number',
        name: 'cqVerification',
        component: CustomerQuoteVerificationStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'submitCustomerQuote',
        component: CustomerQuoteSubmissionStep,
      },
    ],
  },
  {
    path: '/broker-quote',
    meta: {
      layout: 'UserQuoteLayout',
      title: 'User | Submit Quote',
    },
    children: [
      {
        path: '',
        name: 'userQuote',
        component: UserQuoteReadyStep,
        props: ({ query }) => {
          const utmMetrics = <UtmMetricDto>{
            firstClickSource: (query.utm_source_f as string) ?? '',
            firstClickMedium: (query.utm_medium_f as string) ?? '',
            firstClickCampaign: (query.utm_campaign_f as string) ?? '',
            firstClickContent: (query.utm_content_f as string) ?? '',
            firstClickTerm: (query.utm_term_f as string) ?? '',
            secondClickSource: (query.utm_source as string) ?? '',
            secondClickMedium: (query.utm_medium as string) ?? '',
            secondClickCampaign: (query.utm_campaign as string) ?? '',
            secondClickContent: (query.utm_content as string) ?? '',
            secondClickTerm: (query.utm_term as string) ?? '',
            intSource: (query.int_source as string) ?? '',
          };

          return {
            utmMetrics,
            email: query.email,
            from: query.from,
          };
        },
      },
      {
        path: 'verify/email',
        name: 'uqVerification',
        component: UserQuoteVerificationStep,
      },
      {
        path: 'unaccredited-broker/details',
        name: 'unaccreditedBroker',
        component: UserQuoteUnaccreditedBrokerStep,
      },
      {
        path: 'start',
        name: 'startQuote',
        component: UserQuoteStartStep,
      },
      {
        path: 'loan-type',
        name: 'uqSelectLoanType',
        component: UserQuoteLoanTypeStep,
      },
      {
        path: 'loan-purpose',
        name: 'uqLoanPurpose',
        component: UserQuoteLoanPurposeStep,
      },
      {
        path: 'buying/loan-purpose',
        name: 'uqIncomingProperties',
        component: UserQuoteIncomingPropertyStep,
      },
      {
        path: 'selling/property',
        name: 'uqOutgoingProperties',
        component: UserQuoteOutgoingPropertyStep,
      },
      {
        path: 'loan-details/additional-funds',
        name: 'uqLoanDetails',
        component: UserQuoteLoanDetailsStep,
      },
      {
        path: 'applicant/details',
        name: 'uqApplicantDetails',
        component: UserQuoteApplicantsStep,
      },
      {
        path: 'property-ownership',
        name: 'uqPropertyOwnership',
        component: UserQuotePropertyOwnership,
      },
      {
        path: 'income/source',
        name: 'uqIncome',
        component: UserQuoteIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'uqExpenses',
        component: UserQuoteExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'uqAssets',
        component: UserQuoteAssetsStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'submitUserQuote',
        component: UserQuoteSubmissionStep,
      },
    ],
  },
  {
    // /confirmation/review/user_declaration
    // /confirmation/review/income_expense
    // /confirmation/review/equity_release
    // /confirmation/review/bridge_loan
    // /confirmation/review/broker
    path: '/confirmation/review/:finishType',
    name: 'completed',
    component: FinishedStep,
    meta: {
      layout: 'CustomerApplicationLayout',
      title: 'Loan Application',
    },
  },
  {
    path: '/confirmation/review/quote/:finishType',
    name: 'quoteCompleted',
    component: QuoteFinishedStep,
    meta: {
      layout: 'CustomerQuoteLayout',
      title: 'Loan Quote',
    },
  },
  {
    path: '/confirmation/review/quote/:finishType',
    name: 'userQuoteCompleted',
    component: QuoteFinishedStep,
    meta: {
      layout: 'UserQuoteLayout',
      title: 'Loan Quote',
    },
  },
  // ERHL ROUTE
  {
    path: '/erhl-application',
    meta: {
      layout: 'ErhlApplicationLayout',
      title: 'ERHL | Loan Application',
    },
    beforeEnter: async () => {
      const { initialize, isErhlEnabled } = useFeatureFlags();
      await initialize();
      await resolveBrokerIdentity();
      if (!isErhlEnabled()) {
        return { name: 'application' };
      }
      return true;
    },
    children: [
      {
        path: '',
        name: 'erhlReady',
        component: ErhlReadyStep,
      },
      {
        path: 'loan-purpose',
        name: 'erhlLoanPurpose',
        component: ErhlLoanPurposeStep,
      },
      {
        path: 'property-details',
        name: 'erhlPropertyDetails',
        component: ErhlPropertyDetailsStep,
      },
      {
        path: 'loan-details',
        name: 'erhlLoanDetails',
        component: ErhlLoanDetailsStep,
      },
      {
        path: 'applicant/details',
        name: 'erhlApplicantDetails',
        component: ErhlApplicantStep,
      },

      {
        path: 'property-ownership',
        name: 'erhlPropertyOwnership',
        component: ErhlPropertyOwnershipStep,
      },

      {
        path: 'income/source',
        name: 'erhlIncome',
        component: ErhlIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'erhlExpenses',
        component: ErhlExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'erhlAssets',
        component: ErhlAssetsStep,
      },
      {
        path: 'exit-strategy',
        name: 'erhlExitStrategy',
        component: ErhlExitStrategyStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'erhlSubmitApplication',
        component: ErhlSubmissionStep,
      },
      {
        path: 'confirmation/review/erhl/:finishType',
        name: 'erhlCompleted',
        component: ErhlFinishedStep,
        meta: { layout: 'ErhlApplicationLayout', title: 'Loan Application' },
      },
    ],
  },
  // ERHL CUSTOMER (D2C) ROUTE
  // Unlisted: reachable only by direct link, never linked from the product or the portals.
  // The Flagsmith gate, not the URL, is the real access control.
  {
    path: '/erhl-customer-application',
    meta: {
      layout: 'ErhlCustomerApplicationLayout',
      title: 'ERHL | Loan Application',
    },
    beforeEnter: erhlCustomerGuard,
    children: [
      {
        path: '',
        name: 'erhlCustomerReady',
        component: ErhlCustomerReadyStep,
      },
      {
        path: 'loan-purpose',
        name: 'erhlCustomerLoanPurpose',
        component: ErhlCustomerLoanPurposeStep,
      },
      {
        path: 'property-details',
        name: 'erhlCustomerPropertyDetails',
        component: ErhlCustomerPropertyDetailsStep,
      },
      {
        path: 'loan-details',
        name: 'erhlCustomerLoanDetails',
        component: ErhlCustomerLoanDetailsStep,
      },
      {
        path: 'applicant/details',
        name: 'erhlCustomerApplicantDetails',
        component: ErhlCustomerApplicantStep,
      },
      {
        path: 'property-ownership',
        name: 'erhlCustomerPropertyOwnership',
        component: ErhlCustomerPropertyOwnershipStep,
      },
      {
        path: 'income/source',
        name: 'erhlCustomerIncome',
        component: ErhlCustomerIncomeStep,
      },
      {
        path: 'expenses/dependant',
        name: 'erhlCustomerExpenses',
        component: ErhlCustomerExpensesStep,
      },
      {
        path: 'assets-liability/assets',
        name: 'erhlCustomerAssets',
        component: ErhlCustomerAssetsStep,
      },
      {
        path: 'exit-strategy',
        name: 'erhlCustomerExitStrategy',
        component: ErhlCustomerExitStrategyStep,
      },
      {
        path: 'verify/mobile-number',
        name: 'erhlCustomerVerification',
        component: ErhlCustomerVerificationStep,
      },
      {
        path: 'declaration/declaration-form',
        name: 'erhlCustomerSubmitApplication',
        component: ErhlCustomerSubmissionStep,
      },
      {
        path: 'confirmation/review/erhl/:finishType',
        name: 'erhlCustomerCompleted',
        component: ErhlCustomerFinishedStep,
        meta: { layout: 'ErhlCustomerApplicationLayout', title: 'Loan Application' },
      },
    ],
  },
];
